import axios, { AxiosResponse } from 'axios'
import { IReservationSource } from './ReservationSourceModel'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')



export const RS_CREATE_URL = `${API_URL}api/v1/definition/reservationSource/create`
export const RS_GET_ALL_URL = `${API_URL}api/v1/definition/reservationSource/all`
export const RS_DELETE_URL = `${API_URL}api/v1/definition/reservationSource/delete/`
export const RS_UPDATE_URL = `${API_URL}api/v1/definition/reservationSource/update/`



export function createReservationSource(reservationSourceId: IReservationSource) {
  return axios.post(RS_CREATE_URL, reservationSourceId)
}


export function updateReservationSource(reservationSourceId: IReservationSource) {
  return axios.patch(RS_UPDATE_URL +reservationSourceId.id, reservationSourceId)
}


export function deleteReservationSource(reservationSourceId: string) {
  return axios.delete(RS_DELETE_URL +reservationSourceId)
}



export async function allReservationSource(
  page = 0, 
  size = 10, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IReservationSource >>>> {
  return axios.get(RS_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

